import * as R from 'remeda';

export const events = [
  'annotation_content.confirm',
  'annotation_content.export',
  'annotation_content.initialize',
  'annotation_content.started',
  'annotation_content.updated',
  'annotation_content.user_update',
  'annotation_content',
  'annotation_status.changed',
  'annotation_status',
  'upload.created',
  'upload',
  'email.received',
  'email',
  'invocation.manual',
  'invocation.scheduled',
  'invocation.integration',
  'invocation.interface',
  'invocation',
] as const;

/**
 * @noSchema
 */
export type ExtensionEvent = (typeof events)[number];

/**
 * @noSchema
 */
type ExcludeWithoutPrefix<T extends string> = T extends `${infer P}.${infer R}`
  ? `${P}.${R}`
  : never;

/**
 * @noSchema
 */
export type ExtensionEventAction = ExcludeWithoutPrefix<ExtensionEvent>;

export const eventsWithoutPrefixes = R.filter(
  events,
  (event): event is ExtensionEventAction => event.includes('.')
);
